// extracted by mini-css-extract-plugin
module.exports = {"containerLogged":"WelcomeLoggedUser_containerLogged__gjh9b","title":"WelcomeLoggedUser_title__HglK1"};